import * as types from 'modules/interventions/actionTypes';
import { SEND_SELF_SERVICE_SUCCESS } from 'modules/selfServices/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsOpenState */

/** @type {IsOpenState} */
const initialState = false;

/**
 * @returns {IsOpenState}
 */
const open = () => true;

/**
 * @returns {IsOpenState}
 */
const close = () => false;

export default createReducer(initialState, {
  [types.OPEN_RESEND_MODAL]: open,
  [types.CLOSE_RESEND_MODAL]: close,
  [SEND_SELF_SERVICE_SUCCESS]: close
});
